<template>
  <v-autocomplete
      solo
      flat
      :label="label"
      :height="multiple ? 'auto' : height"
      menu-props="offsetY"
      :readonly="readonly"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      :return-object="returnObject"
      :multiple="multiple"
      :chips="chips"
      :deletable-chips="deletableChips"
      :class="[ 'custom-textfield-theme-' + theme ]"
      :hide-details="hideDetails"
      :placeholder="readonly ? '' : placeholder"
      :value="value"
      @change="eventChange"
  ></v-autocomplete>
</template>

<script>
export default {
  name: "SelectBox",
  props: {
    label: {
      default: ''
    },
    placeholder: {
      default: 'โปรดระบุ'
    },
    height: {
      default: '36'
    },
    readonly: {
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    items: {
      default: () => ([])
    },
    itemText: {
      default: undefined
    },
    itemValue: {
      default: undefined
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Boolean,
      default: false
    },
    deletableChips: {
      type: Boolean,
      default: false
    },
    theme: {
      default: '1'
    },
    value: {
      default: undefined
    }
  },
  methods: {
    eventChange (val) {
      this.$emit('onChange', val)
    }
  }
}
</script>

<style scoped lang="scss">

</style>